import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CaptchaLoaderService {
  private loaded = false;

  load(): Promise<void> {
    if (this.loaded) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = environment.captchaSdkUrl;
      s.defer = true;
      s.onload = () => { this.loaded = true; resolve(); };
      s.onerror = (e) => reject(e);
      document.head.appendChild(s);
    });
  }
}

